import style from "./ResetPassword.module.css";
import HeaderAffida from "../../components/header/HeaderAffida";
import React, { useState } from "react";
import z from "zod";
import { Controller, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import axios, {AxiosError, AxiosResponse} from "axios";
import { Alert, Button, TextField } from "@mui/material";
import { endpoint, required_error } from "../../services/shared";
import Snackbar from "@mui/material/Snackbar";
import { apiClient } from "../../services/api";

type FormData = {
  email: string;
};

const formSchema = z.object({
  email: z.string({ required_error }).email("Email non valida"),
});
const defaultValues = {
  email: undefined,
};
export default function ResetPassword() {
  const [loading, setLoading] = useState<boolean>(true);

  const [snackState, setSnackState] = useState<boolean>(false);
  const [snackMessage, setSnackMessage] = useState<{
    severity: any;
    message: string;
  }>({
    severity: "success",
    message: "",
  });
  const form = useForm<FormData>({
    resolver: (data, context, options) =>
      zodResolver(formSchema)(data, context, options),
    defaultValues,
  });
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = form;
  const onSubmit = handleSubmit(async (data) => {
    setSnackState(false);
    let res: AxiosResponse | null = null;
    const payload = {
      email: data.email.toString().toLowerCase().trim(),
    };
    try {
      res = await apiClient.post(`/v1/auth/reset-password`, payload, {
        headers: {
          "Content-Type": "application/json",
        },
      });
    } catch (e: AxiosError | any) {
      console.error("errore", e);
      setSnackMessage({
        severity: "error",
        message: e.response.data.error,
      });
      setSnackState(true);
    }
    if (res?.status && res?.status === 200) {
      setSnackMessage({ severity: "success", message: "Email inviata" });
      setSnackState(true);
    }
    return;
  });
  return (
    <div className={"container"}>
      <HeaderAffida />
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        open={snackState}
        onClose={() => setSnackState(false)}
        autoHideDuration={3000}
      >
        <Alert
          onClose={() => setSnackState(false)}
          severity={snackMessage.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackMessage.message}
        </Alert>
      </Snackbar>
      <div
        style={{
          padding: "1em",
          borderRadius: ".5em",
          margin: "auto",
          marginTop: "1em",
          marginBottom: "1em",
          maxWidth: "480px",
          background: "white",
        }}
      >
        <h3 style={{ marginBottom: "0.25em", padding: 0 }}>Reset password</h3>
        <p
          style={{
            marginTop: "0",
            marginBottom: ".25em",
            padding: 0,
            fontSize: "12px",
            color: "#656565",
          }}
        >
          Inserisci la tua email se valida ti arriverà un SMS per il reset
          password
        </p>
      </div>
      <form
        onSubmit={onSubmit}
        style={{
          padding: "1em",
          borderRadius: ".5em",
          margin: "auto",
          marginBottom: "1em",
          maxWidth: "480px",
          background: "white",
        }}
        className="flex-col gap-2"
      >
        <Controller
          name={"email"}
          control={control}
          render={({ field }) => {
            return (
              <TextField
                {...field}
                fullWidth
                size="small"
                label="Email"
                placeholder="Es. massimo@gmail.com"
                value={field.value ?? ""}
                error={!!errors.email}
                helperText={errors.email?.message}
              />
            );
          }}
        />
        <Button variant={"contained"} type={"submit"} disabled={isSubmitting}>
          {isSubmitting ? "Elaborazione richiesta" : "Invia"}
        </Button>
      </form>
    </div>
  );
}
